module.exports = __webpack_public_path__ + "img/protect.d323b5a9.jpg";